import React from 'react';
import { useAuthenticatedUserInfo } from '../../services/Contexts/AuthenticatedUserInfoContext';
import { useHarvestLeadsAccess } from '../../hooks/useHarvestLeadsAccess';
import PlatformFeatureGate from '../Reusables/PlatformFeatureGate/PlatformFeatureGate';

const HarvestLeadsGate = ({ children }) => {
	const { companyId } = useAuthenticatedUserInfo();
	const access = useHarvestLeadsAccess(companyId);
	return <PlatformFeatureGate access={access}>{children}</PlatformFeatureGate>;
};

export default HarvestLeadsGate;
